import React, { useState } from 'react';

import {
  GetSalesInvoiceDto,
  GetSalesInvoiceDtoStatusEnum,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import ValidationAlert from '../../../app/components/ValidationAlert';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';

interface SalesInvoiceCorrectionButtonProps {
  invoice: GetSalesInvoiceDto;
}

export const SalesInvoiceCorrectionButton: React.FC<
  SalesInvoiceCorrectionButtonProps
> = ({ invoice }) => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const [errors, setErrors] = useState<string[]>([]);

  const canCorrect =
    !invoice.originalInvoice?.id &&
    ((invoice.status === GetSalesInvoiceDtoStatusEnum.Approved &&
      invoice.toKsef !== true) ||
      invoice.status === GetSalesInvoiceDtoStatusEnum.InKSeF);

  if (!canCorrect) {
    return null;
  }

  const handleConfirm = async () => {
    try {
      const correction = await spd.salesInvoices.createCorrection(invoice.id);
      nav.salesInvoiceEditor(correction.id);
    } catch (response) {
      const msgs = await responseErrors(response as ResponseError);
      setErrors(msgs);
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <span onClick={e => e.stopPropagation()}>
      <ValidationAlert
        modal
        show={errors.length > 0}
        errors={errors}
        onHide={() => setErrors([])}
      />
      <ConfirmationButton
        modalSize="lg"
        variant="outline-secondary"
        onOK={handleConfirm}
        confirmation="Uwaga - system wystawi szkic korekty uwzględniający ostatnią korektę wystawioną do tej faktury. Czy kontynuować?"
      >
        Skoryguj
      </ConfirmationButton>
    </span>
  );
};
